import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgBookmark = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      d="M5.167 3.007a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v18.964l-5.876-3.919a2 2 0 0 0-2.22 0l-5.904 3.939z"
      stroke={props.color}
      strokeWidth={2}
    />
  </Svg>
);
const Memo = memo(SvgBookmark);
export default Memo;
